var map = {
	"./views/Admin/AboutSailHero/ChairmanSpeech/ChairmanSpeech.vue": [
		"25f06",
		"chunk-2d0db809",
		"chunk-09339552"
	],
	"./views/Admin/AboutSailHero/CompanyProfile/CompanyProfile.vue": [
		"31c3",
		"chunk-2d0db809",
		"chunk-3f80e18a"
	],
	"./views/Admin/AboutSailHero/CorporateCulture/CulturalPublications.vue": [
		"e69a",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-597a0068",
		"chunk-4c33e7de"
	],
	"./views/Admin/AboutSailHero/CorporateCulture/EmployeeWorld.vue": [
		"70de",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-59c58186",
		"chunk-cfe23060"
	],
	"./views/Admin/AboutSailHero/CorporateCulture/components/PublicationsEdit.vue": [
		"4f39",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-597a0068"
	],
	"./views/Admin/AboutSailHero/CorporateCulture/components/WorldEdit.vue": [
		"41b7",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-59c58186"
	],
	"./views/Admin/AboutSailHero/GloriousHistory/GloriousHistory.vue": [
		"b4fb",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-90e96f62",
		"chunk-055bf7c8"
	],
	"./views/Admin/AboutSailHero/GloriousHistory/components/HistoryEdit.vue": [
		"7244",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-90e96f62"
	],
	"./views/Admin/AboutSailHero/LeadershipCare/LeadershipCare.vue": [
		"61bf",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-25703894",
		"chunk-4abcdf8b"
	],
	"./views/Admin/AboutSailHero/LeadershipCare/components/ShipEdit.vue": [
		"dbfd",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-25703894"
	],
	"./views/Admin/AboutSailHero/OverviewSilhouette/OverviewSilhouette.vue": [
		"3be3",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-3dc59994",
		"chunk-88794c66"
	],
	"./views/Admin/AboutSailHero/OverviewSilhouette/components/SilhouetteEdit.vue": [
		"ae82",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-3dc59994"
	],
	"./views/Admin/AboutSailHero/PartyAffairsConstruction/CarouselPicturesOfPartyBuilding.vue": [
		"0bb1",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-149969ef",
		"chunk-5976866e"
	],
	"./views/Admin/AboutSailHero/PartyAffairsConstruction/IntroductionToTheGeneralPartyBranch.vue": [
		"8f47",
		"chunk-2d0db809",
		"chunk-756a00c6"
	],
	"./views/Admin/AboutSailHero/PartyAffairsConstruction/PartyBuildingDynamics.vue": [
		"08bc",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-1cfcd9f3",
		"chunk-4593f541"
	],
	"./views/Admin/AboutSailHero/PartyAffairsConstruction/components/CarouselPicturesEdit.vue": [
		"09e7",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-149969ef"
	],
	"./views/Admin/AboutSailHero/PartyAffairsConstruction/components/DynamicsEdit.vue": [
		"a59d",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-1cfcd9f3"
	],
	"./views/Admin/AboutSailHero/QualificationsHonors/QualificationsHonors.vue": [
		"d20c",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-36470896",
		"chunk-b548e8ee"
	],
	"./views/Admin/AboutSailHero/QualificationsHonors/components/HonorsEdit.vue": [
		"45ab",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-36470896"
	],
	"./views/Admin/AboutSailHero/SocialResponsibility/SocialResponsibility.vue": [
		"9542",
		"chunk-2d0aa5b8",
		"chunk-5dcc88cf",
		"chunk-74258250"
	],
	"./views/Admin/AboutSailHero/SocialResponsibility/components/ResponsibilityEdit.vue": [
		"bbcc",
		"chunk-2d0aa5b8",
		"chunk-5dcc88cf"
	],
	"./views/Admin/AboutSailHero/components/AttachmentUpload.vue": [
		"8794",
		"chunk-2d0aa5b8",
		"chunk-e2a46920"
	],
	"./views/Admin/AboutSailHero/components/XhEditor.vue": [
		"8c4c",
		"chunk-2d0db809",
		"chunk-2d0e9010"
	],
	"./views/Admin/Business/Product.vue": [
		"746a",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-1bcec937"
	],
	"./views/Admin/Business/ProductType.vue": [
		"351e",
		"chunk-2d0db809",
		"chunk-a7efb370"
	],
	"./views/Admin/Business/Solution.vue": [
		"469b",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-019e9f2e"
	],
	"./views/Admin/Business/SolutionType.vue": [
		"de34",
		"chunk-2d0db809",
		"chunk-62eac273"
	],
	"./views/Admin/Business/components/ProductEdit.vue": [
		"765c",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-2d0d72e3"
	],
	"./views/Admin/Business/components/ProductTypeEdit.vue": [
		"3c67",
		"chunk-2d0db809",
		"chunk-82790a54"
	],
	"./views/Admin/Business/components/SolutionEdit.vue": [
		"a56f",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-2d2086da"
	],
	"./views/Admin/Business/components/SolutionTypeEdit.vue": [
		"818f",
		"chunk-2d0db809",
		"chunk-8275f528"
	],
	"./views/Admin/ContactUs/AfterSalesOffice.vue": [
		"1689",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-c6e53182"
	],
	"./views/Admin/ContactUs/WebsiteMessage.vue": [
		"648c",
		"chunk-907b89be"
	],
	"./views/Admin/ContactUs/components/OfficeEdit.vue": [
		"564a",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-2d0c8a04"
	],
	"./views/Admin/HomeCloud/HomeCloud.vue": [
		"fe82",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-1dc891c8"
	],
	"./views/Admin/HomeCloud/components/HomeCloudEdit.vue": [
		"ad12",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-2d21367a"
	],
	"./views/Admin/HumanResources/OpenPositions.vue": [
		"5700",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-d9611f26"
	],
	"./views/Admin/HumanResources/components/PositionsEdit.vue": [
		"9b1d",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-2d0f0052"
	],
	"./views/Admin/Index.vue": [
		"a66b",
		"chunk-2d208a97"
	],
	"./views/Admin/MemberMain/MemeberMain.vue": [
		"1d3c",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-79e3053a"
	],
	"./views/Admin/MemberMain/components/MemberEdit.vue": [
		"1e62",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-2d0b6906"
	],
	"./views/Admin/NewsCenter/InvestorRelations.vue": [
		"a3ac",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-56750ade"
	],
	"./views/Admin/NewsCenter/NewsTrends.vue": [
		"6c6b",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-275df396"
	],
	"./views/Admin/NewsCenter/PartyWork.vue": [
		"3836",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-8c1b92f6"
	],
	"./views/Admin/NewsCenter/components/NewsEdit.vue": [
		"ec5a",
		"chunk-2d0db809",
		"chunk-2d0aa5b8",
		"chunk-67ca2cb1",
		"chunk-2d2304e0"
	],
	"./views/Client/AboutSailHero/MobileCorporateCulture.vue": [
		"83cd",
		"chunk-11dd965f"
	],
	"./views/Client/AboutSailHero/MobileHumanResources.vue": [
		"8d65",
		"chunk-167e00b8",
		"chunk-51666612"
	],
	"./views/Client/AboutSailHero/MobileIntroduction.vue": [
		"26fd",
		"chunk-777c0aa6"
	],
	"./views/Client/AboutSailHero/MobileLeadershipCare.vue": [
		"3440",
		"chunk-e29d321a"
	],
	"./views/Client/AboutSailHero/MobilePartyBuildingWork.vue": [
		"395f",
		"chunk-173a00b6"
	],
	"./views/Client/AboutSailHero/MobileSocialResponsibility.vue": [
		"e33e",
		"chunk-744559d3"
	],
	"./views/Client/AboutSailHero/components/ChairmanSpeech.vue": [
		"a371",
		"chunk-3b4be63e"
	],
	"./views/Client/AboutSailHero/components/CompanyIntroduction.vue": [
		"65a3",
		"chunk-754932d0"
	],
	"./views/Client/AboutSailHero/components/CorporateCulture.vue": [
		"e05e",
		"chunk-46939ebb"
	],
	"./views/Client/AboutSailHero/components/GloriousHistory.vue": [
		"abb9",
		"chunk-f9246104"
	],
	"./views/Client/AboutSailHero/components/HumanResources.vue": [
		"656e",
		"chunk-230ba854",
		"chunk-7412850d",
		"chunk-2d8a790f"
	],
	"./views/Client/AboutSailHero/components/LeadershipCare.vue": [
		"dd0f",
		"chunk-52d61acf"
	],
	"./views/Client/AboutSailHero/components/NewsDetails.vue": [
		"49c2",
		"chunk-149a6dd4"
	],
	"./views/Client/AboutSailHero/components/OverviewSilhouette.vue": [
		"f17c",
		"chunk-5162b4e2"
	],
	"./views/Client/AboutSailHero/components/Pagination.vue": [
		"0ba1",
		"chunk-1f79d96b"
	],
	"./views/Client/AboutSailHero/components/PartyBuildingWork.vue": [
		"0f7e",
		"chunk-4be2ee94"
	],
	"./views/Client/AboutSailHero/components/QualificationsHonors.vue": [
		"1568",
		"chunk-0bb135ae"
	],
	"./views/Client/AboutSailHero/components/SocialResponsibility.vue": [
		"cff2",
		"chunk-0116c233"
	],
	"./views/Client/AboutSailHero/components/jobPostings.vue": [
		"0a4d",
		"chunk-7412850d"
	],
	"./views/Client/AboutSailHero/components/talentPolicy.vue": [
		"2005",
		"chunk-230ba854"
	],
	"./views/Client/AboutSailHero/index.vue": [
		"a931",
		"chunk-230ba854",
		"chunk-7412850d",
		"chunk-777c0aa6",
		"chunk-167e00b8",
		"chunk-7e6859a5",
		"chunk-04970bea",
		"chunk-19f85b01",
		"chunk-69e62186",
		"chunk-521aa926"
	],
	"./views/Client/Business/Product.vue": [
		"b1be",
		"chunk-7fa247b2",
		"chunk-4d334ced"
	],
	"./views/Client/Business/Solution.vue": [
		"306d",
		"chunk-7fa247b2",
		"chunk-b7467ca0"
	],
	"./views/Client/CloudInfo.vue": [
		"d895",
		"chunk-5fca8172"
	],
	"./views/Client/ContactUs/components/dentify.vue": [
		"9f25",
		"chunk-cc0e2026"
	],
	"./views/Client/ContactUs/index.vue": [
		"5088",
		"chunk-6896a07c"
	],
	"./views/Client/HumanResources/components/Pagination.vue": [
		"d2d2",
		"chunk-67593dc8"
	],
	"./views/Client/HumanResources/index.vue": [
		"f8b3",
		"chunk-3f2c4543",
		"chunk-4f98062c"
	],
	"./views/Client/Index.vue": [
		"bfdb",
		"chunk-2d0aa5b8",
		"chunk-e4e404be",
		"chunk-854790f0"
	],
	"./views/Client/InvestorRelations/InvestorRelations.vue": [
		"b877",
		"chunk-1eaad8be"
	],
	"./views/Client/InvestorRelations/InvestorRelationsDetails.vue": [
		"94dd",
		"chunk-70990c2c"
	],
	"./views/Client/Main.vue": [
		"7c1c"
	],
	"./views/Client/MemberMain/MemberInfo.vue": [
		"a837",
		"chunk-65e28836"
	],
	"./views/Client/MemberMain/MemberMain.vue": [
		"e06a",
		"chunk-71f96759"
	],
	"./views/Client/NewsTrends/NewsDetails.vue": [
		"48f5",
		"chunk-0adf8ebb"
	],
	"./views/Client/NewsTrends/NewsTrends.vue": [
		"5040",
		"chunk-2b381d87"
	],
	"./views/Client/PartyWork/PartyWork.vue": [
		"071b",
		"chunk-074cf2ec"
	],
	"./views/Client/PartyWork/PartyWorkDetails.vue": [
		"51f1",
		"chunk-1d78c424"
	],
	"./views/Client/PartyWork/PartyWorkMore.vue": [
		"77fd",
		"chunk-1679625a"
	],
	"./views/Client/Search/Search.vue": [
		"5114",
		"chunk-61eddfdd"
	],
	"./views/Client/components/Avatar.vue": [
		"2569",
		"chunk-04ed9b3a"
	],
	"./views/Client/components/Menu.vue": [
		"c9da"
	],
	"./views/ErrorPage/401.vue": [
		"7cd5",
		"chunk-c2994768"
	],
	"./views/ErrorPage/401_2.vue": [
		"fde3",
		"chunk-166a4d00"
	],
	"./views/ErrorPage/404.vue": [
		"e17a",
		"chunk-13c5863a"
	],
	"./views/ErrorPage/500.vue": [
		"770d",
		"chunk-fbe48fe2"
	],
	"./views/IframeLayout/Layout.vue": [
		"264d",
		"chunk-0415d18c"
	],
	"./views/Main.vue": [
		"cd56"
	],
	"./views/test1/component/ProllSrcTable.vue": [
		"29be",
		"chunk-55591131"
	],
	"./views/test1/test.vue": [
		"6816",
		"chunk-2d0d055d"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "627e";
module.exports = webpackAsyncContext;